import { RefObject, useEffect, useState } from 'react'

interface ISize {
  width: number
  height: number
}

export const useElementSize = (ref: RefObject<HTMLElement | null>) => {
  const [size, setSize] = useState<ISize>({ width: 0, height: 0 })

  useEffect(() => {
    const el = ref.current
    if (!el || !('ResizeObserver' in window)) return

    const ro = new ResizeObserver(entries => {
      const cr = entries[0].contentRect
      setSize({ width: cr.width, height: cr.height })
    })

    ro.observe(el)
    setSize({ width: el.clientWidth, height: el.clientHeight })

    return () => ro.disconnect()
  }, [ref])

  return size
}
